export default __webpack_public_path__ + "284b49e90da231ff6090068a2ab7795d.png";